import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import Button from "components/button/default";
import PayInf from "./payInf";
import Noti from "./noti";
import { IOutletContext } from "../layout";
import { useAuthContext } from "components/context/authContext";
import "./inf.scss";

type IProps = {
  disabled?: boolean;
  payInf: any;
  children: ReactNode;
  handleResvCancel(): void;
};

export default function BookInf({
  payInf,
  disabled = false,
  children,
  handleResvCancel,
}: IProps) {
  const { t } = useTranslation();
  const { resvStat } = useOutletContext<IOutletContext>();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { lodInf } = useAuthContext();

  const btnDisabled =
    new Date().getFullYear() +
      (new Date().getMonth() + 1).toString().padStart(2, "0") +
      new Date().getDate() ===
      payInf?.rmChkInDt && new Date().getHours() < Number(lodInf?.chkInTi);

  return (
    <div className="book-rm-inf">
      <h2 className="text-blue-300 text-sm md:text-2xl">
        {resvStat !== "cancel" ? t("ttl_dtl_mpg") : t("ttl_bk_dtl_mpg")}
      </h2>
      {children}
      <PayInf payInf={payInf} />
      {!pathname.includes("cancel") && <Noti />}
      <div className="between-center">
        <Button
          text={t("btn_lst_cmm")}
          styels="bg-white h-54 w-[112px] font-18 "
          onClick={() => {
            navigate("/mypage/resv");
          }}
        />
        {resvStat === "wait" &&
          !pathname.includes("cancel") &&
          !btnDisabled && (
            <Button
              text={t("btn_rsv_ccnl_cmm")}
              styels="h-54 px-6 font-18"
              disabled={disabled}
              onClick={handleResvCancel}
            />
          )}
        {pathname.includes("cancel") && (
          <Button
            text={t("btn_cncl_bk_mpg")}
            styels="h-54 w-px-6 font-18"
            disabled={disabled}
            onClick={handleResvCancel}
          />
        )}
      </div>
    </div>
  );
}
